import * as yup from "yup";

const BankDetailsSchema = yup.object().shape({
  bankId: yup.number().required("Bank is required").typeError("Bank is required"),
  accountNumber: yup
    .string()
    .required("Account number is required")
    .matches(/^[0-9]+$/, "Account number must contain only numbers"),
  pensionFund: yup.string().required("Pension fund is required"),
});

export default BankDetailsSchema;
